// extracted by mini-css-extract-plugin
export default {"banner":"EFWoFu","paywallContainer":"okBrtd"};